import React, {Component} from 'react';
import './SignUpComponent.less';
import {FormInput} from '@homeaway/react-form-components';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {validatePasswordConstraint, pwdLengthOptions, validate} from '../../util/password.settings';
import {TrackingContext} from '@homeaway/react-event-tracking';
import aamClient from '../../util/aamClient';

class SignUpComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            password: '',
            loggedIn: false,
            errorMsg: '',
            enablePasswordHint: false
        };
    }

    componentDidMount() {
        if (this.firstNameInput) {
            this.firstNameInput.focus();
        }
        this.context.trigger('generic.event', {eventaction: 'signup.visible', eventcategory: 'lex', eventlabel: 'ums'});
    }

    handleSubmit(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
        if (event.target.name === 'password') {
            if (event.target.value !== '') {
                this.setState({enablePasswordHint: true});
            } else {
                this.setState({enablePasswordHint: false});
            }
        }
    }

    handleError(error, statusCode) {
        if (this.props.marketingOptOut !== null) {
            this.context.trigger('user.account.creation.failure', {
                loginsource: 'lex',
                logintype: 'ums',
                failurereason: `${statusCode}`,
                marketingoptout: this.props.marketingOptOut,
                newusertype: 'traveler'
            });
        } else {
            this.context.trigger('user.account.creation.failure', {
                loginsource: 'lex',
                logintype: 'ums',
                failurereason: `${statusCode}`,
                newusertype: 'traveler'
            });
        }
        this.props.handleError(error);
    }

    signUpSuccess(json) {
        this.props.setEmail(this.props.emailAddress);
        this.props.setFirstName(this.state.firstName);
        this.setState({loggedIn: true});
        if (this.props.marketingOptOut !== null) {
            this.context.trigger('user.account.created', {
                loginsource: 'lex',
                logintype: 'ums',
                newusertype: 'traveler',
                marketingoptout: this.props.marketingOptOut,
                publicuuid: json.publicUuid
            });
        } else {
            this.context.trigger('user.account.created', {
                loginsource: 'lex',
                logintype: 'ums',
                newusertype: 'traveler',
                publicuuid: json.publicUuid
            });
        }
        this.props.setAuthJson(json);
        this.props.updatePage('success');
    }

    checkStatus = (response) => {
        switch (response.status) {
            case 200:
                response.json().then((json) => {
                    this.signUpSuccess(json);
                });
                break;
            case 400:
                this.props.disableLoading();
                let errorMessage = '';
                /* istanbul ignore next */
                response.json().then((json) => {
                    if (json.errors) {
                        let error = '';
                        for (error of json.errors) {
                            const options = error === 'ums.validation.password.length' ? pwdLengthOptions : null;
                            errorMessage += (errorMessage.length ? ' ' : '') + this.props.lingua.read(error, options, 'validation');
                        }
                        this.setState({errorMsg: errorMessage});
                        this.handleError(errorMessage, response.status);
                    } else {
                        this.handleError(this.props.lingua.read('lex.email.rejected'), response.status);
                    }
                });
                break;
            case 401:
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('error.authentication.credentials.bad'), response.status);
                break;
            case 409: // this should never happen since you would only get to this component after checking for existing user but just in case
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('ums.validation.email.unavailable'), response.status);
                break;
            default:
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('error.generic'), response.status);
                break;
        }
    }

    triggerSubmit = (e) => {
        e.preventDefault();
        this.props.enableLoading();
        setTimeout(() => {
            this.submitForm();
        }, 800);
    }

    submitForm() {
        if (!this.validatePassword(true)) {
            this.props.disableLoading();
            return;
        }

        if (this.props.marketingOptOut !== null) {
            this.context.trigger('user.account.creation.attempt', {loginsource: 'lex', logintype: 'ums', marketingoptout: this.props.marketingOptOut, newusertype: 'traveler'});
        } else {
            this.context.trigger('user.account.creation.attempt', {loginsource: 'lex', logintype: 'ums', newusertype: 'traveler'});
        }
        let payload = {
            userName: this.props.emailAddress,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            secret: this.state.password,
            authType: 'HOMEAWAY',
            rememberMe: false
        };
        aamClient.register(payload).then(this.checkStatus);
    }

    editEmail = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.props.updatePage('initial');
    }

    validatePassword(displayErrors) {
        let passwordValid = validate({p: this.state.password}, validatePasswordConstraint);
        if (displayErrors && passwordValid && passwordValid.p.length > 0) {
            let error;
            let errorMessage = '';
            for (error of passwordValid.p) {
                error = error.substr(2);
                const options = error === 'ums.validation.password.length' ? pwdLengthOptions : null;
                errorMessage += (errorMessage.length ? ' ' : '') + this.props.lingua.read(error, options, 'validation');
            }
            this.setState({errorMsg: errorMessage});
            this.props.handleError(errorMessage);
        }
        return !passwordValid;
    }

    validateFields() {
        if (this.state.firstName === '' || this.state.lastName === '' || this.state.password === '' || !this.validatePassword(false)) {
            return false;
        }
        return true;
    }

    render() {
        let passwordFieldClasses = `form-group floating-label ${this.state.password === '' ? '' : 'not-empty'} has-feedback ${this.state.errorMsg === '' ? '' : 'has-error'}`;
        return (
            <div className="SignUpComponent text-center">
                <form onSubmit={this.triggerSubmit} noValidate>
                    <p className="email-display">{this.props.emailAddress}</p>
                    {!this.props.multiUserEnabled && <a onClick={this.editEmail} className="edit-email" href="">{this.props.lingua.read('lex.email.edit')}</a>}
                    <FormInput
                        id="lex-first-name"
                        className= "first-name"
                        name = "firstName"
                        label = {this.props.lingua.read('form.placeholder.firstName')}
                        value = {this.state.firstName}
                        onChange = {this.handleChange}
                        type= "text"
                        autoComplete = "firstName"
                        ref= {(input) => {
                            this.firstNameInput = input;
                        }}
                    />

                    <FormInput
                        id="lex-lastName"
                        name = "lastName"
                        label = {this.props.lingua.read('form.placeholder.lastName')}
                        value = {this.state.lastName}
                        onChange = {this.handleChange}
                        type= "text"
                        autoComplete = "lastName"
                    />
                    <div className={passwordFieldClasses}>
                        <label>{this.props.lingua.read('lex.password.prompt')}</label>
                        <input type={this.props.passwordType} className="form-control" aria-label={this.props.lingua.read('lex.password.prompt')}
                            name="password" onChange={this.handleChange} value={this.state.password} autoComplete = "new-password"
                        />
                        <span className="PasswordShow" onClick={this.props.showHidePassword}>
                            {(this.props.passwordType === 'input') ? this.props.lingua.read('lex.password.hide') : this.props.lingua.read('lex.password.show')}
                        </span>
                        <span className={this.state.errorMsg === '' ? '' : 'help-block'}>{this.state.errorMsg}</span>
                    </div>
                    {this.state.enablePasswordHint && <label className="text-left">{this.props.lingua.read('lex.password.requirements', pwdLengthOptions)}</label>}
                    <div className="Signup_button">
                        <ButtonPrimary type="submit" label={this.props.lingua.read('account.signup.link.text')} disabled={!this.validateFields()}>
                            <LoadingOverlay loading={this.props.isWaiting}/>
                        </ButtonPrimary>
                    </div>
                </form>
            </div>
        );
    }
}

SignUpComponent.contextType = TrackingContext;
export default SignUpComponent;
